const steps = [
  "Diagnostic visuel du mécanisme et des points de fermeture",
  "Démontage de l'huisserie si nécessaire pour accéder aux gonds",
  "Réglage de la compression des galets sur le cadre",
  "Alignement des gonds et paumelles pour un mouvement fluide",
  "Vérification du jeu de la crémone et des points de serrage",
  "Test d'ouverture en battant et en oscillation",
  "Test d'étanchéité au courant d'air",
];

export default function HowWeFix() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Notre méthode
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-6 leading-tight">
            Comment nous <span className="font-serif italic">réglons</span> votre fenêtre
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8">
            Nos techniciens interviennent chez vous avec tout l'outillage nécessaire. Le réglage d'une oscillo-battant demande de la précision : chaque fenêtre a ses propres caractéristiques. Voici les étapes que nous suivons pour garantir un résultat parfait.
          </p>
          <div className="space-y-4">
            {steps.map((step, i) => (
              <div
                key={i}
                className="flex items-start gap-4 bg-white rounded-2xl border border-rose-200 p-5 md:p-6"
              >
                <div className="w-8 h-8 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-check-line text-coral text-sm" />
                </div>
                <span className="text-plum-dark font-medium text-sm md:text-base">{step}</span>
              </div>
            ))}
          </div>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mt-8">
            Une fois le réglage terminé, nous testons la fenêtre en position battante et en position oscillante. Si une pièce est trop usée pour être réglée, nous vous proposons son remplacement sur place — toujours avec la pièce comprise dans le devis.
          </p>
        </div>
      </div>
    </section>
  );
}